import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const useRouteFocus = (targetRef) => {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    const mainScrollParent = targetRef.current?.parentElement;
    if (mainScrollParent) {
      mainScrollParent.scrollTop = 0;
    }

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    targetRef.current?.focus({ preventScroll: true });
  }, [pathname, targetRef]);
};

export default useRouteFocus;
